import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { findGuide } from '../lib/siteNav';

export function GuidePage() {
  const { slug = '' } = useParams();
  const { t } = useTranslation();
  const guide = findGuide(slug);

  if (!guide) {
    return (
      <main className="sa-page">
        <div className="sa-container" style={{ maxWidth: '40rem' }}>
          <h1 className="sa-headline">{t('nav.missing')}</h1>
          <Link to="/" className="sa-button sa-button--ghost">
            {t('common.brand')}
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="sa-page">
      <div className="sa-container" style={{ maxWidth: '40rem' }}>
        <div className="sa-page__header">
          <p className="home-section__eyebrow">{t(`nav.groups.${guide.groupId}`)}</p>
          <h1 className="sa-headline">{t(`nav.items.${guide.item.id}`)}</h1>
        </div>
        <p className="sa-text-muted">{t(`nav.copy.${guide.item.id}`)}</p>
        <p style={{ marginTop: '1.75rem' }}>
          <Link to="/search" className="sa-button sa-button--primary">
            {t('nav.items.buyTicket')}
          </Link>
        </p>
      </div>
    </main>
  );
}
